
import React from "react";
import { Input } from "@/components/ui/input";

interface InvestorsSearchBarProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
}

const InvestorsSearchBar = ({ searchTerm, setSearchTerm }: InvestorsSearchBarProps) => {
  return (
    <div className="flex items-center gap-2">
      <Input
        placeholder="Search investors..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="flex-1"
      />
    </div>
  );
};

export default InvestorsSearchBar;
